import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { BaseUrl, Group_Detail } from "../../services/Url";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import { toast } from "react-toastify";

const GroupEdit = () => {
  const [error, setError] = useState(false);
  const [data, setData] = useState("");
  const [curr, setCurr] = useState(data?.currency || "");
  const [inHand, setInHand] = useState("");
  const [commission, setComission] = useState("");
  const [isHandTrue, setIsHandTrue] = useState();
  const [groupName, setGroupName] = useState(data?.group_name || "");
  const [paymentDue, setPaymentDue] = useState("");
  const [payoutDue, setPayoutDue] = useState("");
  const [frequency, setFrequency] = useState("");
  const [recovery, setRecovery] = useState("First Draw");
  const [bankersFees, setBankersFees] = useState("None");
  const [tommorow, setTommorow] = useState(moment().add(1, "days"));
  const params = useParams();
  const [startDate, setStartDate] = useState();
  const [date, setDate] = useState("");
  const [isPotStatus, setIsPotStatus] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    setDate(e.target.value);
  };

  const singleDetail = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + Group_Detail + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        // if(res.status === 200){
        const responseData = await res.json();
        setData(responseData.data.group);
        setGroupName(responseData.data.group?.group_name);
        setCurr(responseData.data.group?.currency);
        setFrequency(responseData.data?.group.frequency_payment);
        setPaymentDue(
          responseData.data?.group.frequency_payment === "Monthly"
            ? responseData.data?.group.payment_due_date
            : responseData.data?.group.payment_due_day
        );
        setPayoutDue(
          responseData.data?.group.frequency_payment === "Monthly"
            ? responseData.data?.group.payout_due_date
            : responseData.data?.group.payout_due_day
        );
        setStartDate(
          moment(responseData.data?.group.start_date).format("YYYY-MM-DD")
        );
        setInHand(responseData.data?.group.opt_in_hand);
        setIsHandTrue(responseData.data?.group.opt_in_hand > 0 ? true : false);
        setPaymentAmount(responseData.data?.group.payment_amount);
        setRecovery(responseData.data?.group.loss_recovery);
        setBankersFees(responseData.data?.group.bankers_fees);
        setComission(responseData.data?.group.loss_percentage);
        setIsPotStatus(responseData.data.group.potStatus);
        // }else{
        //     localStorage.clear();
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    singleDetail();
  }, []);

  const currHandler = (event) => {
    setCurr(event.target.value);
  };

  const weekDay = [
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
  ];

  const weekDay2 = [
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  const weekDay3 = [
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  const weekDay4 = [
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  const weekDay5 = [
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  const weekDay6 = [
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  const weekDay7 = [{ label: "Sunday", value: "sunday" }];

  const weekDay8 = [];

  const days = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
  ];

  const recoveryHandler = (e) => {
    setRecovery(e);
  };

  const feeHandler = (e) => {
    setBankersFees(e);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let body;
    if (isPotStatus === true) {
      body = JSON.stringify({
        group_name: groupName,
      });
    } else {
      if (frequency === "Monthly") {
        body = JSON.stringify({
          currency: curr,
          group_name: groupName,
          frequency_payment: frequency,
          payment_due_date: paymentDue,
          payout_due_date: payoutDue,
          opt_in_hand: inHand,
          payment_amount: paymentAmount.toString(),
          loss_recovery: recovery,
          bankers_fees: bankersFees,
          start_date: startDate,
          loss_percentage: commission
        });
      } else {
        body = JSON.stringify({
          currency: curr,
          group_name: groupName,
          frequency_payment: frequency,
          payment_due_day: paymentDue,
          payout_due_day: payoutDue,
          opt_in_hand: inHand,
          payment_amount: paymentAmount.toString(),
          loss_recovery: recovery,
          bankers_fees: bankersFees,
          start_date: startDate,
          loss_percentage: commission
        });
      }
    }

    const CompleteUrl = `${BaseUrl}admin/update-group/${params.id}`;
    const res = fetch(CompleteUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body,
    });

    res.then(async (res) => {
      const response = await res.json();
      if (response.response === "success") {
        toast.success("Group Updated Successfully");
      } else {
        toast.error(response.message);
      }
    });
  };

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx grp_edit"
      flexDirection="column"
      justifyContent="flex-start"
    >
      <div className="heading-btn_wrapper">
        <h5 className="fz-20 fw-bold">Edit Group Detail</h5>
      </div>
      <Box className="form_wrapper">
        {!data ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box className="inpt_bx">
                  <Typography variant="h6">Group Name</Typography>
                  <input
                    className="edit_input w-100"
                    defaultValue={groupName}
                    onChange={(e) =>  setGroupName(e.target.value)}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h6" className="sm_label">
                  Currency
                </Typography>
                <FormControl className="w-100">
                  <select
                    className={
                      data?.potStatus ? "edit_input pe-none" : "edit_input"
                    }
                    defaultValue={data?.currency || ""}
                    onChange={(e) =>  setCurr(e.target.value)}
                  >
                    <option key={"GBP"} value={"GBP"}>
                      GBP
                    </option>
                  </select>


                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="h6" className="sm_label">
                  Frequency
                </Typography>
                <FormControl className="w-100">
                  <select
                    className={
                      data?.potStatus ? "edit_input pe-none" : "edit_input"

                    }
                    defaultValue={data?.frequency_payment || ""}
                    onChange={(e) => setFrequency(e.target.value)}
                  >
                    <option key={"Weekly"} value={"Weekly"}>
                      Weekly
                    </option>
                    <option key={"Fortnightly"} value={"Fortnightly"}>
                      Fortnightly
                    </option>
                    <option key={"Monthly"} value={"Monthly"}>
                      Monthly
                    </option>
                  </select>
                </FormControl>
              </Grid>



              <Grid item xs={6}>
                <Typography variant="h6" className="sm_label">
                Payment Due Date
                </Typography>
                <FormControl className="w-100">
                  {frequency === "Monthly" ? (
                    <select
                      className={
                        data?.potStatus ? "edit_input pe-none" : "edit_input"
                      }
                      defaultValue={paymentDue}
                      onChange={(e) => setPaymentDue(e.target.value)}
                    >
                      {days?.length > 0
                        ? days?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  ) : (
                    <>
                      {paymentDue === "monday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : paymentDue === "tuesday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay2?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : paymentDue === "wednesday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay3?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : paymentDue === "thursday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay4?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : paymentDue === "friday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay5?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : paymentDue === "saturday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay6?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={paymentDue}
                          onChange={(e) => setPaymentDue(e.target.value)}
                        >
                          {weekDay7?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="h6" className="sm_label">
                  Payout Date
                </Typography>
                <FormControl className="w-100">
                  {frequency === "Monthly" ? (
                    <select
                      className={
                        data?.potStatus ? "edit_input pe-none" : "edit_input"
                      }
                      defaultValue={payoutDue}
                      onChange={(e) => setPayoutDue(e.target.value)}
                    >
                      {days?.length > 0
                        ? days?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  ) : (
                    <>
                      {payoutDue === "monday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : payoutDue === "tuesday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay2?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : payoutDue === "wednesday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay3?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : payoutDue === "thursday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay4?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : payoutDue === "friday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay5?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : payoutDue === "saturday" ? (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay6?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      ) : (
                        <select
                          className={
                            data?.potStatus
                              ? "edit_input pe-none"
                              : "edit_input"
                          }
                          defaultValue={payoutDue}
                          onChange={(e) => setPayoutDue(e.target.value)}
                        >
                          {weekDay7?.map((item, i) => {
                            return (
                              <option key={item?.value} value={item?.value}>
                                {item?.value}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <Box
                  className={
                    data?.potStatus
                      ? "inpt_slct_bx slct_bx pe-none"
                      : "inpt_slct_bx slct_bx"
                  }
                >
                  <FormControlLabel
                    value="start"
                    className="py-2 w-100 pe-3 pe-none"
                    control={
                      <Switch
                        className="ms-auto pe-none"
                        color="primary"
                        defaultChecked={isHandTrue}
                        onChange={(e) => setIsHandTrue(!isHandTrue)}
                      />
                    }
                    label="Do you want to join group as participant?"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>

              <Grid item xs={6} className="date_picker">
                <Typography variant="h6" className="sm_label">
                  Start Date
                </Typography>
                {/* <Box className="inpt_bx"> */}
                {/* <TextField
                                fullWidth
                                defaultValue={startDate}
                                className="pe-none"
                            /> */}
                {/* <input type="text" className="pe-none" defaultValue={startDate} /> */}
                {/* </Box> */}
                {/* {startDate} */}
                {/* <LocalizationProvider className="p-0" dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                className="p-0"
                                components={["DatePicker"]}
                            >
                                <DatePicker
                                    onChange={(e) => {alert(e.target.value)}}
                                />
                            </DemoContainer>
                        </LocalizationProvider>  <input type='date' min={new Date().toISOString().split('T')[0]} />*/}
                <input
                  type="date"
                  className="edit_input"
                  defaultValue={startDate}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                  }}
                />
              </Grid>

              {isHandTrue ? (
                <Grid item xs={6} className="date_picker">
                  <Typography variant="h6" className="sm_label">
                    Opt in hand
                  </Typography>
                  <FormControl className="w-100">
                    <select
                      defaultValue={inHand}
                      className={ "edit_input pe-none"}
                      onChange={(e) => setInHand(e.target.value)}
                    >
                      <option key={"1"} value={"1"}>
                        1
                      </option>
                      <option key={"2"} value={"2"}>
                        2
                      </option>
                      <option key={"3"} value={"3"}>
                        3
                      </option>
                      <option key={"4"} value={"4"}>
                        4
                      </option>
                      <option key={"5"} value={"5"}>
                        5
                      </option>
                    </select>
                  </FormControl>
                </Grid>
              ) : (
                ""
              )}

              <Grid item xs={6}>
                <Box className="inpt_bx">
                  <Typography variant="h6">Payment Amount</Typography>
                  <TextField
                    fullWidth
                    className={data?.potStatus ? " pe-none" : ""}
                    type="number"
                    value={paymentAmount}
                    name="paymentamount"
                    placeholder="Payment Amount"
                    onChange={(e) => setPaymentAmount(e.target.value)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className="inpt_bx">
                  <Typography variant="h6">
                    Select one of the Bankers Fees Method
                  </Typography>
                  <div
                    className={
                      data?.potStatus ? "tab_btns pe-none" : "tab_btns"
                    }
                  >
                   <div
                      className={
                        bankersFees === "Commission Percentage"
                          ? "tab_btn active"
                          : "tab_btn"
                      }
                      onClick={() => feeHandler("Commission Percentage")}
                    >
                      Commission%
                    </div>
                    <div
                      className={
                        bankersFees === "First Draw +1" ? "tab_btn active" : "tab_btn"
                      }
                      onClick={() => feeHandler("First Draw +1")}
                    >
                      Keep First Draw
                    </div>
                    <div
                      className={
                        bankersFees === "None"
                          ? "tab_btn active"
                          : "tab_btn"
                      }
                      onClick={() => feeHandler("None")}
                    >
                      None
                    </div>
                  </div>
                </Box>
              </Grid>
              {bankersFees === "Commission Percentage" ? (
                <Grid item xs={6}>
                  <Box
                    className={data?.potStatus ? "inpt_bx pe-none" : "inpt_bx"}
                  >
                    <TextField
                      fullWidth
                      type="number"
                      name="commission"
                      placeholder="Commission"
                      defaultValue={commission}
                      onChange={(e) => setComission(e.target.value)}
                    />
                  </Box>
                </Grid>
              ) : (
                ""
              )}
              <Grid item xs={12}>
                <Box className="inpt_bx">
                  <Typography variant="h6">
                    Select one of the Loss Recovery Method
                  </Typography>
                  <div
                    className={
                      data?.potStatus ? "tab_btns pe-none" : "tab_btns"
                    }
                  >
                    <div
                      className={
                        recovery === "Reimburse" ? "tab_btn active" : "tab_btn"
                      }
                      onClick={() => recoveryHandler("Reimburse")}
                    >
                      Reimburse
                    </div>
                    <div
                      className={
                        recovery === "First Draw" ? "tab_btn active" : "tab_btn"
                      }
                      onClick={() => recoveryHandler("First Draw")}
                    >
                      Hold First Draw
                    </div>
                    <div
                      className={
                        recovery === "None"
                          ? "tab_btn active"
                          : "tab_btn"
                      }
                      onClick={() => recoveryHandler("None")}
                    >
                      None
                    </div>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ my: 3 }}>
              <Button
                className="btn btn-design"
                type="submit"
                onClick={(e) => submitHandler(e)}
              >
                Save
              </Button>
            </Box>
          </form>
        )}
      </Box>
    </Box>
  );
};

export default GroupEdit;
